import Vue from 'vue'
import Router from 'vue-router'
import AccessDenied from '@/views/AccessDenied'
import Index from '@/views/Index'
import BusinessIntroduction from '@/views/BusinessIntroduction'
import LatestInformation from '@/views/LatestInformation'
import IpPrivateClub from '@/views/IpPrivateClub'
import TeamIntroduction from '@/views/TeamIntroduction'
import AboutUs from '@/views/AboutUs'
import Details from '@/views/Details'
import IpDetails from '@/views/IpDetails'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HOME',
      title: '首页',
      component: Index,
      show: true
    },
    {
      path: '/businessintroduction',
      name: 'PRACTICES',
      title: '业务介绍',
      component: BusinessIntroduction,
      show: true
    },
    {
      path: '/latestinformation',
      name: 'NEWS',
      title: '最新资讯',
      component: LatestInformation,
      show: true
    },
    {
      path: '/ipprivateclub',
      name: 'SHARING SESSION',
      title: 'IP思享会',
      component: IpPrivateClub,
      show: true
    },
    {
      path: '/teamintroduction',
      name: 'Team Introduction',
      title: '专业团队',
      component: TeamIntroduction,
      show: true
    },
    {
      path: '/aboutus',
      name: 'ABOUT US',
      title: '关于我们',
      component: AboutUs,
      show: true
    },
    {
      path: '/details',
      name: 'Details',
      title: '详情',
      component: Details,
      show: false
    },
    {
      path: '/ipdetails',
      name: 'IpDetails',
      title: '详情',
      component: IpDetails,
      show: false
    },
    // 404 page must be placed at the end !!!
    {
      path: '/404',
      name: 'AccessDenied',
      component: AccessDenied,
      show: false
    },
    { path: '*', redirect: '/404', show: false }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js